import {
  BRDS_SIZE as moleculeNotificationBorderRadiusSize,
  moleculeNotificationAutoClose,
  VARIATIONS as moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {AiIcon} from '@adv-mt/ui/ai-icon'
import {ICON_SIZES} from '@adv-mt/ui/icon'

import {BASE_CLASS} from '../../config.js'

const NOTIFICATION_CLASS = `${BASE_CLASS}Notification`

const NOTIFICATION_TYPES = {
  GENERIC_ERROR: 'GENERIC_ERROR',
  FEEDBACK_SUCCESS: 'FEEDBACK_SUCCESS',
  NEW_CHAT_SUCCESS: 'NEW_CHAT_SUCCESS',
  CHAT_RESULTS_AVAILABLE: 'CHAT_RESULTS_AVAILABLE'
}

const commonNotificationProps = {
  position: 'relative',
  show: true,
  showCloseButton: true,
  roundedCorners: moleculeNotificationBorderRadiusSize.medium,
  variation: moleculeNotificationVariations.negative,
  autoClose: moleculeNotificationAutoClose.medium
}

const NOTIFICATIONS_PROPS = {
  [NOTIFICATION_TYPES.GENERIC_ERROR]: {
    ...{commonNotificationProps},
    type: 'error'
  },
  [NOTIFICATION_TYPES.FEEDBACK_SUCCESS]: {
    ...{commonNotificationProps},
    type: 'success'
  },
  [NOTIFICATION_TYPES.NEW_CHAT_SUCCESS]: {
    ...{commonNotificationProps},
    type: 'success'
  },
  [NOTIFICATION_TYPES.CHAT_RESULTS_AVAILABLE]: {
    ...{commonNotificationProps},
    icon: <AiIcon size={ICON_SIZES.SM} />,
    type: 'success'
  }
}

export {NOTIFICATION_CLASS, NOTIFICATION_TYPES, NOTIFICATIONS_PROPS}
